import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: [ 
        // //首页
        {
            path: '/',
            name:'/',
            component: () => import("@/mobile/Home/HomeIndex.vue"),
        },
        //新闻动态
		{
			path: '/journa',
			name: '/journa',
			component: () => import("@/mobile/Home/journaIndex.vue"),
		},
		// 新闻动态详情
		{
			path: '/new',
			name: '/new',
			component: () => import("@/mobile/Home/newDetails.vue"),
		},
		// //产品服务
		// {
		// 	path: '/appraise',
		// 	name: '/appraise',
		// 	component: () => impor@/mobile/Home/detectionIndex.vuevue"),
		// },
		// //产品服务详情
		// {
		// 	path: '/appraiseDetails',
		// 	name: '/appraiseDetails',
		// 	component: () => impor@/mobile/Home/monitorDetails.vuevue"),
		// },
		//政策法规 
		{
			path: '/policy',
			name: '/policy',
			component: () => import("@/mobile/Home/policyIndex.vue"),
		},
		// 政策法规详情
		{
			path: '/policyDetails',
			name: '/policyDetails',
			component: () => import("@/mobile/Home/policyDetails.vue"),
		},
		// 证书公布
		{
			path: '/publish',
			name: '/publish',
			component: () => import("@/mobile/Home/publishIndex.vue"),
		},
		// 证书详情
		{
			path: '/certificate',
			name: '/certificate',
			component: () => import("@/mobile/Home/certificateDetails.vue"),
		},
		// 咨询建议
		{
			path: '/refer',
			name: '/refer',
			component: () => import("@/mobile/Home/referIndex.vue"),
		},
		//关于我们
		{
			path: '/my',
			name: '/my',
			component: () => import("@/mobile/Home/myIndex.vue"),
		},
		// 登录
		{
			path: '/login',
			name: '/login',
			component: () => import("@/mobile/Home/loginIndex.vue"),
		},
		// 合作伙伴
		{
			path: '/detection',
			name: '/detection',
			component: () => import("@/mobile/Home/detectionIndex.vue"),
		},
		// 合作伙伴详情
		{
			path: '/monitor',
			name: '/monitor',
			component: () => import("@/mobile/Home/monitorDetails.vue"),
		},
		//申请进度
		{
			path: '/plan',
			name: '/plan',
			component: () => import("@/mobile/Home/planIndex.vue"),
		},
    ]
})



export default router;